<template>
    <div>
        <img v-if="!$getState('corporation')['is']" class="login-page__logo reset-pass-creative" :srcset="
            `${$store.state.appUrl}/img/pwa/login/new-password.png, ${$store.state.appUrl}/img/pwa/login/new-password@2x.png`
        " :src="
    `${$store.state.appUrl}/img/pwa/login/new-password.png`
" alt="Reset Password for your Thrive Apps" />
        <h2 class="page-title color-text font-bold text-28 text-text tracking-tight mb-20 text-center"
            :class="{ 'mt-75': $getState('corporation')['is'] }">
            <span class="text-primary">{{ $t("New") }}</span>
            <span class="text-content">{{ $t("Password") }}</span>
        </h2>
        <p class="page-subtitle text-12 text-light_grey text-center mb-40">
            {{ $t("Reset Password Content") }}
        </p>
        <div class="form-items form-with-icons reset-password" :class="{
            'form-enabled':
                values.password !== undefined &&
                values.password !== '' &&
                values.confirm_password !== undefined &&
                values.confirm_password !== '',
        }">
            <FormulateForm #default="{ hasErrors }" v-model="values">
                <FormulateInput v-for="item in schema" :key="item.name" v-bind="item" :hasErrors="hasErrors" />
            </FormulateForm>
        </div>
    </div>
</template>

<script>
export default {
    name: "ResetPassword",

    components: {},

    props: ["phone"],

    mounted() {
        this.$setState('step_header', false);
    },

    data: function () {
        return {
            values: {},
            schema: [
                {
                    type: "password",
                    name: "password",
                    label: ".",
                    placeholder: this.$t("New Password"),
                    validation: [
                        ["required"],
                        [
                            "matches",
                            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                        ],
                    ],
                    "validation-messages": {
                        matches: this.$t(
                            "At least 8 characters, 1 uppercase letter, 1 number, 1 symbol",
                        ),
                    }/*,
                    help: this.$t(
                        "At least 8 characters, 1 uppercase letter, 1 number, 1 symbol",
                    ),*/
                },
                {
                    type: "password",
                    name: "confirm_password",
                    label: ".",
                    placeholder: this.$t("Confirm Password"),
                    validation: "^required|confirm:password",
                    validationName: "Password confirmation",
                },
                {
                    type: "customButton",
                    label: this.$t("Next"),
                    formHandler: this.formHandler,
                },
            ],
        };
    },

    methods: {
        formHandler: function () {
            this.values.phone = this.phone;
            this.$http.post("user/restorepassword", this.values).then(data => {
                if (data && data.status !== undefined && data.status) {
                    this.$setState("forgotPasswordForm", false);
                }
            });
        },
    },
};
</script>
